import React from 'react';

type SnackbarSeverity = 'success' | 'error' | 'warning' | 'info';

interface SnackbarOptions {
    message: string;
    severity?: SnackbarSeverity;
    duration?: number;
}

interface SnackbarData {
    message: string;
    severity: SnackbarSeverity;
    duration: number | null;
}

const useSnackbar = (): {
    showSnackbar: boolean;
    handleSnackbar: (props?: SnackbarOptions) => void;
    snackBarData: SnackbarData;
} => {
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [snackBarData, setSnackBarData] = React.useState<SnackbarData>({
        message: '',
        severity: 'success',
        duration: 4000
    });

    const handleSnackbar = React.useCallback((props?: SnackbarOptions) => {
        if (props) {
            const severity = props.severity ?? 'success';
            let duration: number | null = 4000;
            if (props.duration !== undefined) {
                duration = props.duration;
            }
            setShowSnackbar(true);
            setSnackBarData({ message: props.message, severity, duration });
        } else {
            setShowSnackbar(false);
        }
    }, []);

    return { showSnackbar, handleSnackbar, snackBarData };
};

export default useSnackbar;
